import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledTableBody from 'components/atoms/Tables/TableBody/TableBody.styles';

const TableBody = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'TableBody');

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledTableBody ref={ref} {...innerProps}/>
});

TableBody.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default TableBody;
